import { useEffect, useState } from 'react';
/** Matches the `aiMd` Tailwind breakpoint — the width at which the sidebar stops
 *  being an overlay drawer and becomes the static desktop rail. */
const DESKTOP_MIN_WIDTH = 768;
export const isMobileViewport = () => typeof window !== 'undefined' && window.innerWidth < DESKTOP_MIN_WIDTH;
/**
 * Sidebar open/closed state that follows the viewport.
 *
 * Desktop (>= 768px) opens expanded exactly as before. Phones/small tablets
 * start with the drawer closed, and crossing the breakpoint (rotation, window
 * resize, desktop → responsive devtools) re-syncs it — otherwise a drawer opened
 * on a phone stays latched open as a 16rem rail once the viewport grows, and a
 * rail expanded on desktop covers the whole screen once it shrinks.
 *
 * Layout only: callers keep their own navigation/permission logic.
 */
export default function useResponsiveSidebar() {
    const [isOpen, setIsOpen] = useState(() => !isMobileViewport());
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        let wasMobile = isMobileViewport();
        const onResize = () => {
            const nowMobile = isMobileViewport();
            if (nowMobile !== wasMobile) {
                wasMobile = nowMobile;
                setIsOpen(!nowMobile);
            }
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
    return [isOpen, setIsOpen];
}
